import { H4 } from "@/components/ui/typography";
import { ContainerPrimary, ContainerSecondary } from "../ui";
import { useParams } from "react-router-dom";
import { MISSING_ID_IN_ROUTE, ROLE } from "@/utils/constant";
import { useDownloadHPDBKMZ, useIntegrationHPDBs } from "@/api/generate-hpdb";
import { DownloadButton } from "@/components/ui/button";
import { swalErrorDefault, swalSuccess } from "@/utils/lib/swal";
import { useCurrentUser } from "@/features/auth/useCurrentUser";

export function GenerateKMZHandler() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { roles } = useCurrentUser();
  const canAccess =
    roles?.includes(ROLE.ADMINISTRATOR) ||
    roles?.includes(ROLE.VALIDATOR_DOCUMENT_OFFICER) ||
    roles?.includes(ROLE.MONITORING_TEAM);

  const { data: integrationHPDBs } = useIntegrationHPDBs({ rfsId: id });
  const integrationHPDB = integrationHPDBs?.[0];

  const { mutate: download, isPending: isDownloading } = useDownloadHPDBKMZ();

  function handleDownload() {
    if (!id) {
      throw new Error(MISSING_ID_IN_ROUTE);
    }
    download(
      {
        id,
        name: `HPDB-${integrationHPDB?.rfs.clusterId}.kmz`,
      },
      {
        onSuccess: () => {
          swalSuccess.fire({
            text: "Download Success",
          });
        },
        onError: () => {
          swalErrorDefault.fire();
        },
      },
    );
  }

  return (
    <ContainerPrimary>
      <div className="flex-grow whitespace-nowrap">
        <H4>Convert HPDB to .kmz</H4>
      </div>
      <ContainerSecondary>
        <DownloadButton
          onClick={handleDownload}
          loading={isDownloading}
          className="ml-auto"
          disabled={
            !canAccess || isDownloading || integrationHPDB?.status !== "SUCCESS"
          }
        />
      </ContainerSecondary>
    </ContainerPrimary>
  );
}
